<template>
    <div>
        <div class="field field--scale">
            <label class="label">{{ $t('checkout.configure.inputLabels.scale') }}</label>
            <div class="control">
                <input class="input is-primary" type="number" step="0.01" v-model="objectScale" :min="0.01">
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "Configure3DModelScale",
        computed: {
            ...mapGetters(['currentCartItem']),
            objectScale: {
                get() {
                    let scale = this.currentCartItem.scale
                    if(scale === 0)
                    {
                        return ''
                    }
                    let decimals = scale.toString().split(".")[1];
                    if(decimals)
                    {
                        if(decimals.length > 4) {
                            return Math.round(this.currentCartItem.scale * 10000)/10000;
                        }
                    }
                    return this.currentCartItem.scale;
                },
                set(value) {
                    if(value === '')
                    {
                        value = '0';
                    }
                    this.$store.dispatch('updateCurrentCartItem', {scale: parseFloat(value)});
                }
            },
        },
    }
</script>

<style scoped>

</style>